import { Loader2 } from 'lucide-react';

interface LoadingStateProps {
  title?: string;
  description?: string;
}

export function LoadingState({
  title = 'Loading data',
  description = 'Preparing operational context...',
}: LoadingStateProps) {
  return (
    <div className="flex min-h-44 flex-col items-center justify-center gap-3 rounded-xl border bg-surface-elevated/80 p-6 text-center">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
      <p className="font-medium">{title}</p>
      <p className="max-w-md text-sm text-muted-foreground">{description}</p>
    </div>
  );
}

